import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientPrescriptionsByPatientId = (patientId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientPrescriptions", tenantVal, patientId],
    queryFn: async () => {
      if (!patientId) return [];
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientprescription/getbypatientid/${patientId}`
      );
      return response.data;
    },
    enabled: !!patientId,
  });
};
